import { SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT } from '@oneaudi/unified-web-common';
import styled from 'styled-components';

export const DriveTrainFilterStyle = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 16px;
	margin-bottom: 16px;

	.filter-title {
		color: ${SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT};
	}

	.filter-section {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.filters-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		gap: 8px;
	}
`;
